import { useState } from "react"

import { Popover, PopoverTrigger } from "@radix-ui/react-popover"
import { Check, ChevronDown } from "lucide-react"

import { cn } from "@/lib/utils.ts"

import { Button } from "./ui/button.tsx"
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "./ui/command.tsx"
import { PopoverContent } from "./ui/popover.tsx"

export default function TimezoneSelector({
  value,
  onChange,
}: {
  value: string
  onChange: (tz: string) => void
}) {
  const timezones = ["UTC", "Central Standard Time", "Eastern Standard Time"]
  const [open, setOpen] = useState<boolean>(false)

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className="w-full flex justify-between">
          {value || "Select a timezone"}
          <ChevronDown className="opacity-50 stroke-muted-foreground" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[var(--radix-popover-trigger-width)]">
        <Command>
          <CommandInput placeholder="Search timezones..." />
          <CommandList>
            <CommandEmpty>No timezones found.</CommandEmpty>
            <CommandGroup>
              {timezones.map((tz) => (
                <CommandItem
                  value={tz}
                  key={tz}
                  onSelect={(tz) => {
                    setOpen(false)
                    onChange(tz)
                  }}
                >
                  {tz}
                  <Check className={cn("ml-auto ", tz == value ? "opacity-100" : "opacity-0")} />
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  )
}
